import { Form } from "react-bootstrap";
import styled from "styled-components";

interface IProps {
  minWidth: string | undefined;
}

export const Content = styled.div`
  @media only screen and (max-width: 1100px) {
    margin-top: 2rem;
  }
`;

export const Input = styled.div<IProps>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.3rem;

  label {
    min-width: ${({ minWidth }) => (minWidth ? minWidth : "")};
  }

  input {
    box-shadow: var(--color-input-shadow);
    border: 1px solid #b3b3b3;
    border-radius: 4px;
    padding: 2.8px 9px;

    ::placeholder {
      font-size: 12px;
      color: var(--color-input-placeholder);
    }
  }

  .inputMask {
    font-size: 13px;
    padding: 2.5px 9px;
    border-radius: 4px;
    transition: all 0.08s ease-in-out;

    ::placeholder {
      font-size: 12px;
      color: var(--color-input-placeholder);
    }

    :focus {
      outline: 4px solid #c2dbfe;
      border: 1px solid #86b7fe;
    }
  }
`;

export const Wrapper = styled.div``;

export const FormInput = styled(Form.Control)`
  font-size: 12px;

  ::placeholder {
    font-size: 12px;
    color: var(--color-input-placeholder);
  }
`;

export const Error = styled.div`
  font-size: 10px;
  color: #dc2229;
  margin-top: 0.2rem;
`;
